import { Api, Http } from '../../models/index';
import { GetApi } from '../resources/api/GetApi';
import { GetLink } from '../resources/GetLink';
import { UseCase } from '../UseCase';

export class Logout implements UseCase<string, Promise<boolean>> {
    private getLink = new GetLink<Api.Rel>();
    private getApi: GetApi;

    constructor(
        http: Http,
        private location: Location = window.location
    ) {
        this.getApi = new GetApi(http);
    }

    execute(): Promise<boolean> {
        return this.getApi.execute().then((api) => {
            const link = this.getLink.execute({ parent: api, rel: 'logout' });
            if (link) {
                this.location.href = encodeURI(link.href);
            } else {
                throw new Error('Cannot find logout link');
            }

            return true;
        });
    }
}
